import React from 'react';
import { FormControl, InputLabel, Select as SelectMUI, MenuItem, makeStyles } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';

import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  filter: {
    margin: theme.spacing(3, 0),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    width: '100%',
    // maxWidth: 400,
    // border: '1px solid red'
  },
}));

function Select(props) {
  const classes = useStyles();
  const { t } = useTranslation();

  function handleChangeStatus(event) {

    props.handle(event.target.value)
  }



  return (
    <div className={classes.filter}>
      <FormControl
        variant="filled"
        style={{ width: '100%', maxWidth: 500 }}
      >
        <InputLabel id="select-status-label">tipo da infraestrutura</InputLabel>
        <SelectMUI
          labelId="select-status-label"
          id="select-status"
          fullWidth
          value={props.value}
          onChange={handleChangeStatus}
          placeholder='Selecione'
          label="tipo da infraestrutura"
        // disableUnderline
        >
          <MenuItem value={'local'}>{t('local')}</MenuItem>
          <MenuItem value={'occupationArea'}>{t('area_de_ocupacao')}</MenuItem>
          <MenuItem value={'businessUnit'}>{t('unidade_de_negocio')}</MenuItem>
        </SelectMUI>
      </FormControl>
    </div>
  );
}

export { Select };
